import { render, staticRenderFns } from "./paramsList.vue?vue&type=template&id=4590ea73&"
import script from "./paramsList.vue?vue&type=script&lang=js&"
export * from "./paramsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "paramsList.vue"
export default component.exports